import { createStructuredSelector } from 'reselect';

import { fetchGAWState } from './LoadingPageSelectors';
import { selectAccountData } from './AgreementFlowSelectors';
import {
  selectAdvisors,
  mapData,
  selectCsrBusinessFunction,
} from '../../../../../selectors/globalSelectors';

export const mapRecognition = (state) => {
  const { grantRecognition } = fetchGAWState(state);
  return grantRecognition;
};

export const selectGrantRecognition = (state) => {
  const { grantRecognition } = mapRecognition(state);
  return grantRecognition;
};

export const selectAccountName = (state) => {
  const { accountName } = mapRecognition(state);
  return accountName;
};

export const selectInHonorOfName = (state) => {
  const { inHonorOfName } = mapRecognition(state);
  return inHonorOfName;
};

export const selectInMemoryOfName = (state) => {
  const { inMemoryOfName } = mapRecognition(state);
  return inMemoryOfName;
};

export const selectNotifyFirstName = (state) => {
  const { notifyFirstName } = mapRecognition(state);
  return notifyFirstName;
};

export const selectNotifyLastName = (state) => {
  const { notifyLastName } = mapRecognition(state);
  return notifyLastName;
};

export const selectThirdParty = (state) => {
  const { thirdParty } = mapRecognition(state);
  return thirdParty;
};

export const selectIncludeAdvisorInfo = (state) => {
  const { includeAdvisorInfo } = mapRecognition(state);
  return includeAdvisorInfo;
};

export const selectPermissionToPublish = (state) => {
  const { permissionToPublish } = fetchGAWState(state);
  return permissionToPublish;
};

export const selectDescription = (state) => {
  const { purpose } = fetchGAWState(state);
  if (purpose && purpose.description) {
    return purpose.description;
  }
  return '';
};

export const selectGrantPurposeId = (state) => {
  const { grantPurposeId } = fetchGAWState(state);
  return grantPurposeId;
};

export const selectAdditionalComments = (state) => {
  const { purpose } = fetchGAWState(state);
  if (purpose && purpose.additionalComments) {
    return purpose.additionalComments;
  }
  return '';
};

export const selectPurposeCertification = (state) => {
  const { purpose } = fetchGAWState(state);
  if (purpose && purpose.purposeCertification) {
    return purpose.purposeCertification;
  }
  return '';
};

export const selectGranteeOrgFirstName = (state) => {
  const { granteeOrgFirstName } = fetchGAWState(state);
  return granteeOrgFirstName;
};

export const selectGranteeOrgLastName = (state) => {
  const { granteeOrgLastName } = fetchGAWState(state);
  return granteeOrgLastName;
};

export const selectGranteeOrgPhoneNumber = (state) => {
  const { granteeOrgPhoneNumber } = fetchGAWState(state);
  return granteeOrgPhoneNumber;
};

export const selectGranteeOrgEmailAddr = (state) => {
  const { granteeOrgEmailAddr } = fetchGAWState(state);
  return granteeOrgEmailAddr;
};

export const selectEdit = (state) => {
  const { edit } = fetchGAWState(state);
  return edit;
};

export const contactPurposeDerivedStates = createStructuredSelector({
  recognition: selectGrantRecognition,
  accountName: selectAccountName,
  inHonorOfName: selectInHonorOfName,
  inMemoryOfName: selectInMemoryOfName,
  notifyFirstName: selectNotifyFirstName,
  notifyLastName: selectNotifyLastName,
  thirdParty: selectThirdParty,
  includeAdvisorInfo: selectIncludeAdvisorInfo,
  permissionToPublish: selectPermissionToPublish,
  grantPurposeDropdown: selectDescription,
  grantPurposeId: selectGrantPurposeId,
  grantPurposeComments: selectAdditionalComments,
  purposeCertification: selectPurposeCertification,
  firstName: selectGranteeOrgFirstName,
  lastName: selectGranteeOrgLastName,
  phone: selectGranteeOrgPhoneNumber,
  email: selectGranteeOrgEmailAddr,
  editMode: selectEdit,
});
